import React from 'react';
import { useNavigate } from 'react-router-dom';

const PaymentFailure = () => {
    const navigate = useNavigate();

    return (
        <div>
            <h1>Payment Failed!</h1>
            <p>Unfortunately, your payment could not be processed. Please try again.</p>
            <button onClick={() => navigate('/checkoutPayment')}>Try Again</button>
        </div>
    );
};

export default PaymentFailure;
